import { useSnapshot } from 'valtio'
import cn from 'classnames'
import { type ReactElement, useEffect } from 'react'
import format from 'date-fns/format'
import { parseISO } from 'date-fns'
import { recurringPaymentProxy } from '../../../../../shared/proxies/recurringPaymentProxy'
import {
  RecurringPaymentsAmountCell
} from '../../index/components/RecurringPaymentsTable/components/RecurringPaymentsRows/components/AmountCell/RecurringPaymentsAmountCell'
import { RecurringPaymentStatus } from '../../../../../shared/types/GlobalRecurringPaymentsStatus'
import {
  NonLinkingTableCell
} from '../../index/components/RecurringPaymentsTable/components/RecurringPaymentsRows/components/RpTableCell'

import { handleSkipUnskipPayment } from '../utils'
import ResumeButton from '../RecurringPaymentDetail/components/ResumeButton'
import {
  executeRecurringTransactionDetermineFuturePayments
} from '../executeRecurringTransactionDetermineFuturePayments'
import FutureStatusCell from './FutureStatusCell'
import SkipResumeButton from './SkipResumeButton'

export function FutureOccurrencesRows (): ReactElement {
  const { recurringPayment, futureOccurrences } = useSnapshot(recurringPaymentProxy)

  useEffect(() => {
    void executeRecurringTransactionDetermineFuturePayments()
  }, [recurringPayment])

  if (!recurringPayment?.nextPaymentDate || !recurringPayment?.billingCycle) {
    return (<></>)
  }
  const skipped = recurringPayment?.skipNextPayment
  const notActive = recurringPayment?.status !== RecurringPaymentStatus.Active

  if (notActive || !futureOccurrences) {
    return (
      <tr>
        <td colSpan={2} className={cn('border-t border-b border-gray-300 p-3 font-light')}>
          No Upcoming Payments
        </td>
        <td colSpan={2}>
          <ResumeButton isEnded={recurringPayment?.status === RecurringPaymentStatus.Ended} />
        </td>
      </tr>
    )
  }

  return (
    <>
      {futureOccurrences?.map((futureDate, i) => {
        const firstRow = i === 0
        const notLastRow = i !== futureOccurrences.length - 1

        return (
          <tr
            key={i}
            className={
              cn('opacity-90 my-1 text-sm animate__animated animate__fadeIn',
                notLastRow && 'border-b border-gray-100')
            }
          >
            <NonLinkingTableCell>
              {format(parseISO(futureDate), 'MMM d, y')}
            </NonLinkingTableCell>

            <NonLinkingTableCell>
              <RecurringPaymentsAmountCell recurringPayment={recurringPayment} />
            </NonLinkingTableCell>

            <NonLinkingTableCell>
              {firstRow ? <FutureStatusCell isSkipped={skipped} /> : <FutureStatusCell isSkipped={false} />}
            </NonLinkingTableCell>

            <NonLinkingTableCell>
              {firstRow && <SkipResumeButton additionalClasses="px-12  py-1" clickFunction={handleSkipUnskipPayment} isSkipped={skipped} />}
            </NonLinkingTableCell>

          </tr>
        )
      })}
    </>
  )
}
